import { render, staticRenderFns } from "./GatSubGroup.vue?vue&type=template&id=5b11deec&scoped=true&"
import script from "./GatSubGroup.vue?vue&type=script&lang=js&"
export * from "./GatSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./GatSubGroup.vue?vue&type=style&index=0&id=5b11deec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11deec",
  null
  
)

export default component.exports